import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { Stars } from './ReviewCard';

const LABEL = { pending: 'Pendiente', approved: 'En la home', hidden: 'Oculta' };

export default function ReviewsModeration() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/reviews').then(r => setItems(r.data)).catch(() => {}); }, []);

  const setStatus = async (id, status) => {
    try {
      await api.post(`/reviews/${id}/status`, { status });
      setItems(items.map(r => (r.id === id ? { ...r, status } : r)));
    } catch { toast.error('No se pudo actualizar'); }
  };

  return (
    <section className="mt-6 border border-stilo-ink/10 bg-white p-6" data-testid="reviews-moderation">
      <div className="flex justify-between items-baseline">
        <h2 className="font-serif text-2xl">Valoraciones</h2>
        <span className="overline">{items.filter(r => r.status === 'pending').length} por revisar</span>
      </div>
      {items.length === 0 && <p className="text-stilo-ink3 py-6">Todavía no hay valoraciones. Llegarán cuando finalices conversaciones.</p>}
      <div className="mt-4 divide-y divide-stilo-ink/10">
        {items.map(r => (
          <div key={r.id} className="py-4 flex flex-wrap gap-4 justify-between" data-testid={`mod-review-${r.id}`}>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-3"><Stars value={r.rating} size="w-4 h-4" testid={`mod-stars-${r.id}`} /><span className="text-xs text-stilo-ink3">{LABEL[r.status]}</span></div>
              {r.comment && <p className="mt-2 text-stilo-ink2">«{r.comment}»</p>}
              <Link to={`/asesoria/${r.consultation_id}`} className="text-xs text-stilo-ink3 hover:text-stilo-gold">{r.display_name} · {r.package_name} →</Link>
            </div>
            <div className="flex gap-2 self-center">
              {r.status !== 'approved' && <button onClick={() => setStatus(r.id, 'approved')} className="px-3 py-2 bg-stilo-ink text-stilo-bg text-xs uppercase tracking-[0.12em]" data-testid={`mod-approve-${r.id}`}>Mostrar</button>}
              {r.status !== 'hidden' && <button onClick={() => setStatus(r.id, 'hidden')} className="px-3 py-2 border border-stilo-ink/20 text-xs uppercase tracking-[0.12em]" data-testid={`mod-hide-${r.id}`}>Ocultar</button>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
